import { makeStyles } from '@material-ui/core';

import { COLORS } from 'src/data/ui';

export default makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      marginLeft: theme.spacing(1),
      columnGap: 5,
      '& div': {
        display: 'inline-block',
        position: 'relative',
        animationName: '$flash',
        animationDuration: '1s',
        animationIterationCount: 'infinite',
        animationTimingFunction: `${theme.transitions.easing.easeInOut}`,
        width: 4.5,
        height: 4.5,
        borderRadius: '50%',
        backgroundColor: COLORS.primary.default,
        '&:nth-child(2)': {
          animationDelay: '0.2s',
        },
        '&:nth-child(3)': {
          animationDelay: '0.4s',
        },
      },
    },
    '@keyframes flash': {
      '0%': {
        opacity: 0,
      },
      '50%': {
        opacity: 1,
      },
    },
  }),
  { name: 'DotsLoader' }
);
